import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'
import { Link } from '@jelly/ui'

const MoreCoverageContainer = styled.div`
	width: 100%;
	display: inline-block;
	background: ${({ theme }) => theme.colors.tertiary};
	margin-top: 10px;
	padding: 15px 25px 30px 25px;
`
const Header = styled.div`
	color: ${({ theme }) => theme.colors.white};
	font-size: 22px;
	text-transform: uppercase;
`
const Articles = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
	}
`
const ArticleContainerLink = styled(Link)`
	align-items: center;
	display: flex;
	background: ${({ theme }) => theme.bestPicks.moreCoverageArticleBackground};
	color: ${({ theme }) => theme.colors.white};
	flex-direction: row;
	margin-top: 10px;
	padding: 12px 10px;
	width: 100%;
	${({ theme }) => theme.MQ.M} {
		width: 32%;
	}
`
const Article = styled.div`
	width: 201px;
	font-size: 11px;
	color: ${({ theme }) => theme.colors.white};
	height: 100%;
	margin-left: 12px;
	text-transform: uppercase;
`
const ArticleTitle = styled.div`
	color: ${({ theme }) => theme.bestPicks.moreCoverageTitleColor};
	font-size: 14px;
	margin-top: 4px;
	text-transform: none;
`
const ArticleImage = styled.img`
	height: 60px;
	width: 60px;
`
/**
 * More Coverage feature. Displays related content as specified by CCM editors
 * @param {Object} author :: JSON data decribing author
 * @param {string} title :: the morecoverage section title
 * @param {array}  morecoverage :: the morecoverage section content data array
 */
export const MoreCoverage = ({ title, morecoverage }) => {
	return (
		<MoreCoverageContainer>
			<Header>{title}</Header>
			<Articles>
				{morecoverage.map((article, i) => (
					<ArticleContainerLink
						alt={article.title}
						href={article.canonical}
						id={`mbp_${i}_morecoverage`}
						key={i}
					>
						<ArticleImage
							className="lazyload"
							data-src={makeImgResizerUrl({ src: article.thumbnail.path, method: 'rc', w: 60, h: 60 })}
							alt={article.title}
						/>
						<Article>
							{article.author.displayName}
							<ArticleTitle>{article.title} </ArticleTitle>
						</Article>
					</ArticleContainerLink>
				))}
			</Articles>
		</MoreCoverageContainer>
	)
}

MoreCoverage.propTypes = {
	morecoverage: array,
	title: string,
}
